import { useEffect, useState } from "react";

import { isEmpty, isUndefined, omitBy } from "@s-libs/micro-dash";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import evaluateRestQuery from "@/remoteState/evaluateRestQuery";

const getRosterSyncByProvider = async (provider) => {
  const response = await evaluateRestQuery(
    `${MONOLITH_ORIGIN}/api/v2/roster-sync/`,
  );
  if (response.error) return response;
  return omitBy(
    {
      ...response,
      data: response.data.find((sync) => sync.provider === provider),
    },
    isUndefined,
  );
};

const useClassroomRosterSyncFollowUpGet = (
  provider,
  { ms = 3000, skip = false } = {},
) => {
  const shouldSkip = skip || !provider;
  const [response, setResponse] = useState({
    loading: !shouldSkip,
    initialLoading: !shouldSkip,
  });

  const onRosterSyncResponse = (response) => {
    setResponse((current) => {
      if (isEmpty(response.data)) {
        return { ...response, loading: false };
      } else {
        const syncing = !response.data.time_completed;
        const syncingCompleted = Boolean(!syncing && current.syncing);
        return { ...response, loading: false, syncing, syncingCompleted };
      }
    });
  };

  const onFollowUp = async () => {
    setResponse((response) =>
      response.loading ? response : { ...response, loading: true },
    );
    const response = await getRosterSyncByProvider(provider);
    onRosterSyncResponse(response);
    if (isEmpty(response.data) || response.data.time_completed) return;
    await new Promise((resolve) => setTimeout(resolve, ms));
    onFollowUp();
  };

  const followUpRosterSync = (rosterSync) => {
    onRosterSyncResponse({ data: { ...rosterSync, time_completed: null } });
    onFollowUp();
  };

  useEffect(() => {
    if (shouldSkip) return;
    onFollowUp();
  }, [provider]);

  return [response, followUpRosterSync];
};

export default useClassroomRosterSyncFollowUpGet;
